import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import Reveal from '../components/common/Reveal';
import { SectionHeader } from '../components/ui';

export default function GalleryPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get('/gallery').then(r => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <div style={{ padding: '120px 40px 40px', textAlign: 'center', background: 'linear-gradient(160deg,var(--cream),var(--soft-orange))' }}>
        <SectionHeader title="Image" accent="Gallery" sub="A visual journey through events, art, and heritage" />
      </div>
      <section style={{ padding: '40px 40px 80px', maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(200px,1fr))', gap: 16 }}>
          {items.map((g, i) => (
            <Reveal key={g.id} delay={i * .06}>
              <div style={{ aspectRatio: '1', borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '3rem', background: g.image_url ? `url(${g.image_url}) center/cover` : g.color, position: 'relative', overflow: 'hidden', cursor: 'pointer', transition: 'transform .4s' }}
                onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'} onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}>
                {!g.image_url && g.emoji}
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(0deg,rgba(0,0,0,.6),transparent 60%)', display: 'flex', alignItems: 'flex-end', padding: 16, opacity: 0, transition: 'opacity .3s', color: 'white', fontSize: 14, fontWeight: 500 }}
                  onMouseEnter={e => e.currentTarget.style.opacity = 1} onMouseLeave={e => e.currentTarget.style.opacity = 0}>{g.title}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
